import { BankTransaction, UpdateBanktransactionParams } from '../../../commonTypes/BankingTypes'
import beam from './beam'

export const updateBankTransaction = (p: UpdateBanktransactionParams) => beam.patch<BankTransaction>(`/api/bankTransactions/${p.bankTransactionId}`, p)

export const getOrganizationBankTransactions = (organizationId: string) => beam.get<BankTransaction[]>(`/api/organizations/${organizationId}/bankTransactions`)
